import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import { TextStyle, Color, FontSize } from '@tiptap/extension-text-style'
import { Table } from '@tiptap/extension-table'
import TableRow from '@tiptap/extension-table-row'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import Image from '@tiptap/extension-image'
import { TypedOrderedList } from '@/lib/richTextLists'

/** Shared TipTap extensions for KB rich text (including inline images). */
export function buildRichTextExtensions() {
  return [
    StarterKit.configure({
      // Custom ordered list supports type=1 / type=a (numbers vs letters)
      orderedList: false,
    }),
    TypedOrderedList,
    Underline,
    TextStyle,
    Color,
    FontSize,
    Image.configure({
      inline: false,
      allowBase64: true,
      HTMLAttributes: {
        class: 'kb-rich-image',
      },
    }),
    Table.configure({
      resizable: true,
      HTMLAttributes: { class: 'kb-rich-table' },
    }),
    TableRow,
    TableHeader,
    TableCell,
  ]
}
